;(function () {
  const scrollbarSettings = {
    slidesPerView: 2.15,
    spaceBetween: 16,
    mousewheel: {
      forceToAxis: true,
    },
    speed: 400,
    allowTouchMove: true,
    breakpoints: {
      990: {
        slidesPerView: 4.15,
      },
      3000: {
        slidesPerView: 4.25,
      },
    },
  }

  const sliderSettings = {
    slidesPerView: 1.65,
    spaceBetween: 16,
    speed: 800,
    allowTouchMove: true,
  }

  const initSlider = (section, settings) => {
    if (!section || !section.classList.contains('popular-products-section')) {
      return
    }

    const sliderContainer = section.querySelector('.popular-products')
    if (!sliderContainer) {
      return
    }

    const swiperEl = section.querySelector('.popular-products__layout')
    const swiperWrapper = section.querySelector('.popular-products__list')
    const slides = section.querySelectorAll('.popular-products__item')

    if (!swiperEl || !swiperWrapper || !slides || !slides.length) {
      return
    }

    const mobSlidesPreView = swiperEl.classList.contains('popular-products__layout--visible-overflow') ? 'auto' : 1.65

    swiperEl.classList.add('swiper')
    swiperWrapper.classList.add('swiper-wrapper')
    slides.forEach((slide) => slide.classList.add('swiper-slide'))

    const progressBar = section.querySelector('.swiper-scrollbar')
    const pagination = section.querySelector('.popular-products__pagination')
    const nextBtn = section.querySelector('.popular-products__navigation-button-next')
    const prevBtn = section.querySelector('.popular-products__navigation-button-prev')

    const updatedScrollbarSettings = {
      ...scrollbarSettings,
      scrollbar: progressBar
        ? {
            el: progressBar,
            grabCursor: true,
            draggable: true,
            hide: false,
          }
        : undefined,
      pagination: pagination
        ? {
            el: pagination,
            type: 'bullets',
            clickable: true,
          }
        : undefined,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'swiper-button-disabled',
      },
    }

    const updatedSliderSettings = {
      ...sliderSettings,
      slidesPerView: mobSlidesPreView,
      scrollbar: progressBar
        ? {
            el: progressBar,
            grabCursor: true,
            draggable: true,
            hide: false,
          }
        : undefined,
      pagination: pagination
        ? {
            el: pagination,
            type: 'bullets',
            clickable: true,
          }
        : undefined,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'swiper-button-disabled',
      },
    }

    try {
      const swiper = new Swiper(swiperEl, settings === 'bar' ? updatedScrollbarSettings : updatedSliderSettings)
      section.dataset.swiperInstance = JSON.stringify(swiper)
    } catch (error) {}
  }

  const destroySlider = (section) => {
    if (!section || !section.dataset.swiperInstance) return

    try {
      const swiper = JSON.parse(section.dataset.swiperInstance)
      const swiperEl = section.querySelector('.popular-products__layout')
      const swiperWrapper = section.querySelector('.popular-products__list')
      const slides = section.querySelectorAll('.popular-products__item')

      if (!swiperEl || !slides || !slides.length || !swiperWrapper) {
        return
      }

      swiper.destroy(true, true)
      delete section.dataset.swiperInstance

      swiperEl.classList.remove('swiper')
      swiperWrapper.classList.remove('swiper-wrapper')
      slides.forEach((slide) => slide.classList.remove('swiper-slide'))
    } catch (error) {}
  }

  const initPopularProducts = (section) => {
    if (!section || !section.classList.contains('popular-products-section')) return

    const sliderContainer = section.querySelector('.popular-products')
    const cardsLayout = sliderContainer.dataset.layout || 'grid'
    const cardsMobileLayout = sliderContainer.dataset.layoutMobile || 'column'

    let currentLayout = null

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries
      let newLayout

      if (entry.contentRect.width < 576) {
        newLayout = cardsMobileLayout === 'slider' ? 'slider' : 'column'
      } else {
        newLayout = cardsLayout === 'bar' ? 'bar' : 'grid'
      }

      if (newLayout !== currentLayout) {
        currentLayout = newLayout

        if (section.dataset.swiperInstance) {
          destroySlider(section)
        }

        if (newLayout === 'slider' || newLayout === 'bar') {
          initSlider(section, newLayout)
        }
      }
    })

    sectionResizeObserver.observe(section)
  }

  const animateProductCards = (section) => {
    if (
      !section ||
      !section.classList.contains('popular-products-section') ||
      !section.querySelector('.animate-on-scroll')
    ) {
      return
    }

    const popularProductsLayout = section.querySelector('.popular-products__layout')
    if (!popularProductsLayout) return

    ScrollTrigger.create({
      trigger: popularProductsLayout,
      start: '20% bottom',
      end: 'bottom top',
      onEnter: () => popularProductsLayout.classList.add('animated'),
    })
  }

  document.querySelectorAll('.popular-products-section').forEach((section) => {
    initPopularProducts(section)
    animateProductCards(section)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initPopularProducts(event.target)
    animateProductCards(event.target)
  })
})()
